import { escape } from "../utils/dom";
export default (function (data) {
  return "<span class=\"tag ".concat(escape(data.style), "\" data-value=\"").concat(escape(data.value), "\">\n        ").concat(escape(data.text), "\n        ").concat(data.removable ? '<div class="delete is-small" data-tag="delete"></div>' : '', "\n    </span>");
});